





























































import {Vue,Component, Ref} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import BtnDefault from '@/components/UI/BtnDefault.vue'
import Modal from '@/components/UI/Modal.vue'
import IArrow from '@/components/icons/IArrow.vue'
import ICheck from '@/components/icons/ICheck.vue'
import IClose from '@/components/icons/IClose.vue'

const dialog = namespace('dialog')
const workspace = namespace('workspace')

@Component({
  components: {
    BtnDefault,
    Modal,
    IArrow,
    ICheck,
    IClose,
  }
})
export default class FullPlan extends Vue {
  @dialog.Getter('fullPlanShow') protected fullPlanShow: any
  @dialog.Mutation('SetFullPlanShow') protected SetFullPlanShow: any
  @workspace.Getter('getCurrentExhibition') protected getCurrentExhibition: any
  @workspace.Getter('getPlan') protected getPlan: any
  @workspace.Getter('getPlanStatus') protected getPlanStatus: any
  @workspace.Action('joinCompanyExhibition') protected joinCompanyExhibition: any
  @workspace.Action('changePlan') protected changePlan: any

  showModalFree: boolean = false

  closeFullPlan() {
    this.SetFullPlanShow(false)
  }

  async choosePlan(plan:any) {
    if(this.getCurrentExhibition.wasStarted && this.getCurrentExhibition.companyParticipation === null) {
      await this.joinCompanyExhibition({
        company: this.$route.params.code,
        show: this.getCurrentExhibition.code,
        plan: 'free'
      })
      await this.changePlan({
        params: {id: this.getCurrentExhibition.companyParticipation._id},
        body: {plan: plan},
        _show: this.getCurrentExhibition.code
      })
      this.SetFullPlanShow(false)
      this.showModalFree = false
    } else {
      if(!this.getCurrentExhibition.companyParticipation) {
        await this.joinCompanyExhibition({
          company: this.$route.params.code,
          show: this.getCurrentExhibition.code,
          plan: plan
        })
        this.SetFullPlanShow(false)
        this.showModalFree = false
      } else {
        if(this.getCurrentExhibition.companyParticipation.plan != plan) {
          await this.changePlan({
            params: {id: this.getCurrentExhibition.companyParticipation._id},
            body: {plan: plan},
            _show: this.getCurrentExhibition.code
          })
        }
        this.SetFullPlanShow(false)
        this.showModalFree = false
      }
    }
    if(this.$route.name == 'Corporate' || this.$route.name == 'Personal') {
      this.$router.push({name: 'Settings', params:{code: this.$route.params.code, showCode: this.getCurrentExhibition.code}}).catch(() => {})
    }
  }


}

